module.exports = __webpack_public_path__ + "static/media/basemap_google_satellite.fd0e4ebb.png";